package com.cybersoftsolution.cybersoftsolutionweb.pages


import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.FormMethod
import org.jetbrains.compose.web.attributes.action
import org.jetbrains.compose.web.attributes.method
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Form
import org.jetbrains.compose.web.dom.Text
import androidx.compose.runtime.*
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.components.capcha.SliderCaptchaBootstrap
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.*
import org.jetbrains.compose.web.css.*


@Composable
fun RecaptchaExample() {
    var recaptchaResponse by remember { mutableStateOf<String?>(null) }
    var formSubmitted by remember { mutableStateOf(false) }
    val recaptchaElementId = "recaptcha-container" // ID para el div del reCAPTCHA


    DisposableEffect(Unit) {


        onDispose { /* Limpieza si es necesaria al desmontar */ }

    }
    /**
    <html>
    <head>
    <title>reCAPTCHA demo: Simple page</title>
    <script src="https://www.google.com/recaptcha/enterprise.js" async defer></script>
    </head>
    <body>
    <form action="" method="POST">
    <div class="g-recaptcha" data-sitekey="6Lf7St0qAAAAAFnw7mHTpGkdZpTdg0EqEH3zYIg1" data-action="LOGIN"></div>
    <br/>
    <input type="submit" value="Submit">
    </form>
    </body>
    </html>
     */


    var captchaVerified by remember { mutableStateOf(false) }

    Box(
        contentAlignment = Alignment.Center,
        modifier = Modifier
            .fillMaxSize()
    ) {



            Column(
//                horizontalAlignment = Alignment.CenterHorizontally,
//                verticalArrangement = Arrangement.Center,
                modifier =
                Modifier.fillMaxWidth()
//                    .padding(20.px)

            ) {

                SliderCaptchaBootstrap(
                    onVerified = {
                        captchaVerified = true
                    },
                    onError = { errorMessage ->
                        captchaVerified = false
                    }
                )


                Button(
                    attrs = Modifier
                        .onClick {
                            if (captchaVerified) {
                                window.alert("Formulario Enviado Correctamente!")
                                // Aquí podrías enviar los datos del formulario
                            } else {
                                window.alert("Por favor, verifica el captcha antes de enviar el formulario.")
                            }
                        }
                        .disabled(!captchaVerified)
                        .margin(top = 20.px)
                        .toAttrs()

                ) {
                    Text("Enviar Formulario")
                }
            }





    }

}



@Page
@Composable
fun Cap() {
    RecaptchaExample()
}